import { combineReducers } from 'redux';
import filter from './filters';
import { bulkActionsReducer as bulk } from '../shared/index/bulk';
import { dataReducer as data } from '../shared/index/data';
import defaultView from './defaultView';

export default combineReducers({
  filter,
  data,
  bulk,
  defaultView,
  meta: (meta = {}) => meta,
});
